// extracted by mini-css-extract-plugin
module.exports = {"app__container":"core_app__container__2n9mv","maincontents__container":"core_maincontents__container__3t2OU"};